<a class="ch-list-entry-container"
   routerLinkActive="active-entry"
   [routerLink]="['/certificate-holder', item().uuid]"
   [title]="item().companyName"
   (click)="onEntryClick()"
>

  <div class="ch-link flex flex-col">
    <span class="truncate ch-link-company-name">{{ item().companyName }}</span>
    <span class="truncate ch-link-description">{{ item().countryLabel }}</span>
    <div class="ch-tags-container card pt-2.5">
      <p-tag [value]="this.usedIn + ((this.usedIn === 0 || this.usedIn > 1) ? ' Certificates'  : ' Certificate')"/>
    </div>
  </div>
</a>
